import { PackageItem } from 'sections/Membership/types';

const premiumPackageItems: PackageItem[] = [
  {
    id: 1,
    title: 'Logistics Explorer Web Integration',
    tooltipActive: true,
    tooltipDescription: 'If you join as a premium member you will get the platform integration as a white label solution for your business.',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 2,
    title: 'Listing in the members directory',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 3,
    title: 'Verified Membership Certificate and Badge',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 4,
    title: 'Rates advertisement on SeaRates.com',
    tooltipActive: true,
    tooltipDescription: 'Largest tariff search engine in the world for international shipping',
    iconType: 'checked',
    packageType: 'premium',
    url: 'https://searates.com',
  },
  {
    id: 5,
    title: 'Vendor’s access to SeaRates open leads',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/shipping-leads',
  },
  {
    id: 6,
    title: 'Ship Schedules Web integration: 600 s/m',
    tooltipActive: true,
    tooltipDescription: '600 searches per month available with a premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 7,
    title: 'Container Tracking Web integration: 100 с/m',
    tooltipActive: true,
    tooltipDescription: '100 unique containers per month available with a Premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 8,
    title: 'Widgets customization',
    tooltipActive: true,
    tooltipDescription: 'Premium members can customize our white-label Logistics Explorer, Tracking System and Ship Schedules tools for their websites!',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 9,
    title: 'Dedicated account manager',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
];

const premiumPlusPackageItems: PackageItem[] = [
  {
    id: 1,
    title: 'Logistics Explorer Web Integration',
    tooltipActive: true,
    tooltipDescription: 'If you join as a premium member you will get the platform integration as a white label solution for your business.',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 2,
    title: 'Listing in the members directory',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 3,
    title: 'Verified Membership Certificate and Badge',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 4,
    title: 'Rates advertisement on SeaRates.com',
    tooltipActive: true,
    tooltipDescription: 'Largest tariff search engine in the world for international shipping',
    iconType: 'checked',
    packageType: 'premium',
    url: 'https://searates.com',
  },
  {
    id: 5,
    title: 'Vendor’s access to SeaRates open leads',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/shipping-leads',
  },
  {
    id: 6,
    title: 'Ship Schedules Web integration: 600 s/m',
    tooltipActive: true,
    tooltipDescription: '600 searches per month available with a premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 7,
    title: 'Container Tracking Web integration: 300 с/m',
    tooltipActive: true,
    tooltipDescription: '300 unique containers per month available with a Premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 8,
    title: 'Widgets customization',
    tooltipActive: true,
    tooltipDescription: 'Premium members can customize our white-label Logistics Explorer, Tracking System and Ship Schedules tools for their websites!',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 9,
    title: 'Dedicated account manager',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
];

const PackageAnnualPricing = {
  premium: 3999,
  premiumPlus: 4999,
};

export { 
  // freePackageItems, 
  premiumPackageItems, 
  premiumPlusPackageItems,
  PackageAnnualPricing,
};